import "./Header.scss";
import useAccessToken from "../../utils/useAccessToken";

function Header() {
  const { organizationData } = useAccessToken();

  const active = (pathname) => {
    if (window.location.pathname.includes(pathname)) return true;
    return false;
  }

  return (
    <ul>
      <li className={active("/commissions") && `active`}>
        <a href="/commissions">Commission</a>
      </li>
      {/* <li className={active("/logs") && `active`}>
        <a href="/logs">Logs</a>
      </li> */}
      <li className={active("/processed-documents") && `active`}>
        <a href="/processed-documents">Processed Documents</a>
      </li>
      <li className={active("/integrations") && `active`}>
        <a href="/integrations">Integrations</a>
      </li>
      <li className="right-aligned logout-btn">
        <a href="/logout">Logout</a>
      </li>
      {organizationData.is_internal && (
        <li className={`${active("/internal-admin") && `active`} right-aligned`}>
          <a href="/internal-admin">Internal Admin</a>
        </li>
      )}
    </ul>
  );
}

export default Header;
